initExpandableElements();
initSwitchableElements();
initAccordionElements();
// initMobileMenuDrawer();
initNavScrollToSections();
initUrlHashScrollToSections();
//initDetectScrollPastSplash();
initHidables();
// setMobileMenuDrawerWidth();
initSectionsWithRevealableColumns();
initReviewsCustomisations();
//initSubscriptionProductVariantSwitch();

initSubscribersOnlyFunctionalities();

// IMPORTANT -- THE SUBSCRIPTION WONT BE ADDED TO CART WITHOUT THIS
initSubscriptionPlanSelector();

/* ------------------------------ Functions ------------------------------ */

//product_variant_selector


function initSubscribersOnlyFunctionalities() {
  console.log("initSubscribersOnlyFunctionalities()");
  let subs_only_overlays = document.querySelectorAll(".subscribers_only_overlay");
  for (let index = 0; index < subs_only_overlays.length; index++) {
    const overlay = subs_only_overlays[index];
    let form_to_open = overlay.dataset.form;
    overlay.addEventListener('click', function (event) {
      console.log("form_to_open = "+ form_to_open);
      window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', form_to_open]);
    });
  }
}

function initSubscriptionPlanSelector() {
  // IMPORTANT -- THE SUBSCRIPTION WONT BE ADDED TO CART WITHOUT THIS
  let variantSelector = document.querySelector(".product_variant_selector");
  if (variantSelector == null) {
    return;
  }
  variantSelector.addEventListener('change', function (event) {
    setTimeout(() => { // fire after any other change events attached to this element elsewhere 
      let activeVariant = document.querySelector(".select-popout__item.is-active a");
      let currentPrice = activeVariant.dataset.optionPrice;
      console.log(activeVariant.dataset.variant);

      let relatedSubscriptionOption = document.getElementById("variant_"+activeVariant.dataset.variant);
      if (relatedSubscriptionOption) {
        let subRelatedSubscriptionOption = document.getElementById("sub_option_"+relatedSubscriptionOption.dataset.index);
        relatedSubscriptionOption.checked = true;
        if (subRelatedSubscriptionOption) {
          subRelatedSubscriptionOption.checked = true;
        }
      } else {
        document.querySelectorAll('input[name="selling_plan"]').forEach(function(radio) {
          radio.checked = false;
        });
        let oneTimeGroupRadio = document.querySelector('input[name="selling-plan-group"][value=""]');
        if (oneTimeGroupRadio) {
          oneTimeGroupRadio.checked = true;
        } else {
          document.querySelectorAll('input[name="selling-plan-group"]').forEach(function(radio) {
            radio.checked = false;
          });
        }
      }

      let displayPrice = document.querySelector(".product__submit__item .price");
      displayPrice.innerHTML = currentPrice;

      // Update the hidden variant id field on EVERY cart-add form on the page
      // (there can be more than one — e.g. a main form and a separate sticky/mobile
      // cart bar form — and only updating the first one found can silently leave
      // the actually-submitted form pointing at the wrong variant).
      let cartForms = document.querySelectorAll('form[action*="/cart/add"]');
      cartForms.forEach(function(cartForm) {
        let idInput = cartForm.querySelector('input[name="id"]');
        if (idInput && activeVariant.dataset.variant) {
          idInput.value = activeVariant.dataset.variant;
        }
      });
    }, 0);
  });
};



function initSubscriptionProductVariantSwitch() {
  document.addEventListener('DOMContentLoaded', function () {
    const label = document.querySelector('.dropdown__filter-selected');
    const options = Array.from(document.querySelectorAll('.dropdown__select-option'));
    const variantInput = document.getElementById('product_variant_input');
    const sellingPlanInput = document.getElementById('product_selling_plan_input');
    const toggle = document.getElementById('filter-switch');

    function syncDropdownState() {
      const selectedVariantId = variantInput.value;
      const selectedSellingPlanId = sellingPlanInput.value;

      const matchedOption = options.find(
        (option) =>
          option.getAttribute('data-variant-id') === selectedVariantId &&
          option.getAttribute('data-selling-plan-id') === selectedSellingPlanId
      );

      if (matchedOption) {
        label.innerHTML = matchedOption.innerHTML;
      } else {
        const defaultOption = options[0];
        if (defaultOption) {
          label.innerHTML = defaultOption.innerHTML;
          variantInput.value = defaultOption.getAttribute('data-variant-id');
          sellingPlanInput.value = defaultOption.getAttribute('data-selling-plan-id');
        }
      }
    }

    options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.stopPropagation();

        const variantId = option.getAttribute('data-variant-id');
        const sellingPlanId = option.getAttribute('data-selling-plan-id');

        label.innerHTML = option.innerHTML;
        variantInput.value = variantId;
        sellingPlanInput.value = sellingPlanId;

        const displayPriceElement = document.querySelector('.kx-section.subscription_product .price');
        const selectedPrice = option.getAttribute('data-variant-price');
        displayPriceElement.innerHTML = selectedPrice;

        toggle.checked = false;
      });
    });

    syncDropdownState();

    window.addEventListener('pageshow', function (e) {
      syncDropdownState();
    });

    document.addEventListener('click', (e) => {
      const isDropdown = e.target.closest('.dropdown');
      if (!isDropdown) {
        toggle.checked = false;
      }
    });
  });
}

function initExpandableElements() {
  let expandableElements = document.querySelectorAll('.expandable li');

  for (let index = 0; index < expandableElements.length; index++) {
    
    let blockImageGroup = expandableElements[index].dataset.imgGroup;
    let firstBlockImage = document.querySelector(".list_item_image_0."+blockImageGroup);

    if(firstBlockImage) {
      firstBlockImage.classList.remove("inactive");
    }

    const element = expandableElements[index];
    element.addEventListener('click', (event) => {
      let currentExpandableContainer = event.currentTarget.closest('.expandable');
      let currentExpandableElements = currentExpandableContainer.querySelectorAll('li');

      for (let i = 0; i < currentExpandableElements.length; i++) {
        const el = currentExpandableElements[i];
        el.classList.remove('selected');
      }

      event.currentTarget.classList.add('selected');

      let currentExpandedBlock = event.currentTarget.querySelector('.expanded_block');
      let currentExpandedBlock_pos_y = currentExpandedBlock.getBoundingClientRect().y;
      let currentExpandableContainer_pos_y = currentExpandableContainer.getBoundingClientRect().y;
      let currentExpandedBlock_pos_y_from_parent = currentExpandedBlock_pos_y - currentExpandableContainer_pos_y;
      if (
        currentExpandedBlock.offsetHeight + currentExpandedBlock_pos_y_from_parent >
        currentExpandableContainer.offsetHeight
      ) {
        currentExpandableContainer.style.height =
          currentExpandedBlock.offsetHeight + currentExpandedBlock_pos_y_from_parent + 'px';
      } else {
        currentExpandableContainer.style.height = '';
      }

      let current_image = document.getElementById(event.currentTarget.dataset.linkedImg);
      let imageGroup = document.querySelectorAll(".list_item_image."+event.currentTarget.dataset.imgGroup);
      function hideAllImages() {
        for (let index = 0; index < imageGroup.length; index++) {
          const image = imageGroup[index];
          image.classList.add("inactive");
        }
      }
      if (current_image) {
        hideAllImages();
        current_image.classList.remove("inactive");
      } else {
        hideAllImages();
      }
    });
  }
}

function initSwitchableElements() {
  let switchableButtons = document.querySelectorAll('.switchable_button');
  let clickCounter = 1;

  for (let index = 0; index < switchableButtons.length; index++) {
    const button = switchableButtons[index];
    button.addEventListener('click', (event) => {
      let switchablesClass = button.dataset.switchables;
      let switchables = document.getElementsByClassName(switchablesClass);
      let numberOfSwitchableBlocks = parseInt(button.dataset.switchablesBlocks);

      for (let i = 0; i < switchables.length; i++) {
        const el = switchables[i];
        el.classList.add('hidden');
      }

      if (clickCounter == numberOfSwitchableBlocks) clickCounter = 0;

      let currentActiveSwitchables = document.querySelectorAll('.' + switchablesClass + '.s_index_' + clickCounter);

      for (let i = 0; i < currentActiveSwitchables.length; i++) {
        currentActiveSwitchables[i].classList.remove('hidden');
      }

      clickCounter++;
    });
  }
}

function initAccordionElements() {
  let accordion_elements = document.querySelectorAll('.accordion_element');
  let sub_rew = document.querySelector('.sub_rew');

  for (let index = 0; index < accordion_elements.length; index++) {
    const accordion_element = accordion_elements[index];

    accordion_element.addEventListener('click', (event) => {
      for (let i = 0; i < accordion_elements.length; i++) {
        const el = accordion_elements[i];
        if (el !== event.currentTarget) {
          el.classList.remove('expanded');
        }
      }

      event.currentTarget.classList.toggle('expanded');

      if (event.currentTarget.classList.contains('reviews_button')) {
        sub_rew.classList.toggle('hidden');
      } else {
        sub_rew.classList.add('hidden');
      }
    });
  }
}

function initReviewsCustomisations() {
  const click_overlay = document.querySelector('.click_overlay');
  if(click_overlay !== null) {
    click_overlay.addEventListener('click', (event) => {
      scrollToSection('.CarouselWidget');
    });
  }
}

function setBodyColorScheme() {
  const colorSchemes = ['scheme_black_on_white', 'scheme_white_on_red', 'scheme_red_on_beige'];

  colorSchemes.forEach((scheme) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            for (let i = 0; i < colorSchemes.length; i++) {
              document.body.classList.remove(colorSchemes[i]);
            }
            document.body.classList.add(scheme);
          }
        });
      },
      { threshold: 0.5 }
    );

    const elements = document.querySelectorAll('.' + scheme);

    elements.forEach((element) => {
      observer.observe(element);
    });
  });
}

function initDetectScrollPastSplash() {
  let firstSplash = document.querySelector('.kx-splash:first-of-type');
  let header = document.querySelector('.kx_header');

  if (!firstSplash || !header) {
    return;
  }

  let headerHeight = header.offsetHeight;

  let options = {
    threshold: headerHeight / window.innerHeight,
  };

  let observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        document.body.classList.add('scrolled_past_splash');
      } else {
        document.body.classList.remove('scrolled_past_splash');
      }
    });
  }, options);

  observer.observe(firstSplash);
}

function initMobileMenuDrawer() {
  let hamburger_icon = document.querySelector('.hamburger_menu_icon');
  hamburger_icon.addEventListener('click', (event) => {
    if (document.body.classList.contains('mobile_menu_drawer_expanded')) {
      document.body.classList.remove('mobile_menu_drawer_expanded');
    } else {
      document.body.classList.add('mobile_menu_drawer_expanded');
    }
  });
}

function initNavScrollToSections() {
  let mainMenuLinks = document.querySelectorAll('.header__menu a');
  let mobileMenuLinks = document.querySelectorAll('.drawer__main-menu a');
  let scrollToSectionButtons = document.querySelectorAll('.scroll_to_section_button');

  prepareMenuLinks(mainMenuLinks);
  prepareMenuLinks(mobileMenuLinks);
  prepareMenuLinks(scrollToSectionButtons);

  function prepareMenuLinks(links) {
    for (let index = 0; index < links.length; index++) {
      const link = links[index];

      if (link.href.indexOf('#') > -1) {
        let sectionClassToScrollTo = '.' + link.href.split('#')[1];
        link.addEventListener('click', (event) => {
          event.preventDefault();
          let sectionExists = document.querySelectorAll(sectionClassToScrollTo).length != 0;
          if (sectionExists) {
            scrollToSection(sectionClassToScrollTo);
            document.body.classList.remove('mobile_menu_drawer_expanded');
            document.getElementsByClassName("drawer__close")[0].click();
          } else {
            let hash = '#' + link.href.split('#')[1];
            if (window.location.pathname != '/') {
              window.location.href = '/' + hash;
            }
          }
        });
      }
    }
  }
}

function initUrlHashScrollToSections() {
  if (location.hash.length > 0) {
    let sectionClassToScrollTo = '.' + location.hash.split('#')[1];
    let sectionExists = document.querySelectorAll(sectionClassToScrollTo).length != 0;
    if (sectionExists) {
      scrollToSection(sectionClassToScrollTo);
    }
  }
}

function initHidables() {
  let revelable_elements = document.querySelectorAll('.revelable_element');
  for (let index = 0; index < revelable_elements.length; index++) {
    const revelable_element = revelable_elements[index];
    if (revelable_element.querySelector('.revelable_button') != null) {
      let revelable_element_button = revelable_element.querySelector('.revelable_button');
      revelable_element_button.addEventListener('click', (event) => {
        event.preventDefault();
        for (let i = 0; i < revelable_elements.length; i++) {
          const other_element = revelable_elements[i];
          if (other_element != revelable_element) {
            other_element.classList.remove('active');
          }
        }

        revelable_element.classList.toggle('active');
      });
    }
  }
}

function setMobileMenuDrawerWidth() {
  let drawer = document.querySelector('.menu_drawer');
  let logo = document.querySelector('.header_logo');
  let offset = 4;
  let spaceForLogo = logo.getBoundingClientRect().x * 2 + logo.getBoundingClientRect().width - offset;
  let calcDrawerWidth = window.outerWidth - spaceForLogo;

  if (window.outerWidth < 700) {
    drawer.style.right = calcDrawerWidth * -1 + 'px';
    drawer.style.width = calcDrawerWidth + 'px';
  } else {
    drawer.style.right = (window.outerWidth / 2) * -1 + 'px';
    drawer.style.width = window.outerWidth / 2 + 'px';
  }
}

function initSectionsWithRevealableColumns() {
  let sectionsWithRevealableColumns = document.querySelectorAll('.revelable_columns');
  for (let index = 0; index < sectionsWithRevealableColumns.length; index++) {
    const section = sectionsWithRevealableColumns[index];
    let view_all_cta = section.querySelector('.view_all_cta');
    if (view_all_cta != null) {
      view_all_cta.addEventListener('click', (event) => {
        event.preventDefault();
        let columnsToShow = section.querySelectorAll('.column');
        for (let i = 0; i < columnsToShow.length; i++) {
          columnsToShow[i].classList.remove('hidden_on_desktop');
          columnsToShow[i].classList.remove('hidden_on_mobile');
        }
        view_all_cta.remove();
      });
    }
  }
}

function scrollToSection(sectionClass) {
  let scrollOffset = document.querySelectorAll('.theme__header')[0].offsetHeight * -1;
  let sectionToScrollTo = document.querySelectorAll(sectionClass)[0];
  let y = sectionToScrollTo.getBoundingClientRect().top + window.scrollY + scrollOffset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}